export var EmailRecipientGroup;
(function (EmailRecipientGroup) {
    EmailRecipientGroup[EmailRecipientGroup["AttendeesConfirmed"] = 1] = "AttendeesConfirmed";
    EmailRecipientGroup[EmailRecipientGroup["AttendeesNotRegistered"] = 2] = "AttendeesNotRegistered";
    EmailRecipientGroup[EmailRecipientGroup["AttendeesAndGuests"] = 3] = "AttendeesAndGuests";
    EmailRecipientGroup[EmailRecipientGroup["RegisteredRSVP"] = 4] = "RegisteredRSVP";
})(EmailRecipientGroup || (EmailRecipientGroup = {}));
export var AttendeeFilter;
(function (AttendeeFilter) {
    AttendeeFilter[AttendeeFilter["All"] = 1] = "All";
    AttendeeFilter[AttendeeFilter["RsvpOnly"] = 2] = "RsvpOnly";
    AttendeeFilter[AttendeeFilter["AttendeesOnly"] = 3] = "AttendeesOnly";
})(AttendeeFilter || (AttendeeFilter = {}));
